<div class="page-container">
    <ngx-spinner bdColor="#000000aa" size="medium" color="#64b2cd" type="line-scale-pulse-out-rapid" [fullScreen]="true">
        <h6>Processando...</h6>
    </ngx-spinner>

    <div class="working-area p-4">
        <h1 class="page-title m-0" [class.mb-4]="!isAdminAll">
            <i class="fas fa-chart-pie mr-2"></i>
            <span>Dashboard</span>
        </h1>

        <p class="page-subtitle m-0 pl-3 pt-3 pr-2 pb-2">
            <i class="fas fa-level-up-alt mr-2"></i>
            Obtenha dados e estatísticas sobre a execução de seus Fluxos no E-Flow
        </p>

        <hr />

        @if (isAdminAll) {
            <div class="tabs-container">
                <button type="button" class="btn btn-outline-default"
                        [class.active]="$activeTab() == 'available-flow-definitions'"
                        (click)="$activeTab.set('available-flow-definitions')"
                        (keyDown)="$activeTab.set('available-flow-definitions')"
                >
                    <span>Definições de Fluxo disponíveis</span>
                </button>

                <button type="button" class="btn btn-outline-default"
                        [class.active]="$activeTab() == 'finished-flow-instances'"
                        (click)="$activeTab.set('finished-flow-instances')"
                        (keyDown)="$activeTab.set('finished-flow-instances')"
                >
                    <span>Instâncias de Fluxo executadas</span>
                </button>

                <button type="button" class="btn btn-outline-default"
                        [class.active]="$activeTab() == 'flow-instances-by-inbox'"
                        (click)="$activeTab.set('flow-instances-by-inbox')"
                        (keyDown)="$activeTab.set('flow-instances-by-inbox')"
                >
                    <span>Fluxos Instanciados (por Caixa de Fluxo)</span>
                </button>
            </div>
        }

        @switch ($activeTab()) {
            @case ('available-flow-definitions') {
                <available-flow-definitions></available-flow-definitions>
            }
            @case ('finished-flow-instances') {
                <finished-flow-instances></finished-flow-instances>
            }
            @case ('flow-instances-by-inbox') {
                <flow-instances-by-inbox></flow-instances-by-inbox>
            }
        }
    </div>
</div>
